<!--
 * @Description: file content
 * @Author:
 * @Date: 2024-11-18 17:05:38
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-03-04 15:57:33
-->
<script>
// 这个页面使用 options api，不使用 setup 和 ts,为了以后迁移到其他系统
import { getFeedNotReadCountByCategory, getUserFeedTimelineList, setRead } from '@/api/message-notify'
import { useWorkspaceStore } from '@/store'

export default {
  name: 'MessageNotify',
  data() {
    return {
      notifyValue: 99,
      // category 分类, 0-系统通知 1-团队通知 2-升级通知 -1-全部
      tabs: [
        { name: 'upgrade', label: '升级通知', category: 2, unread: 0 },
        { name: 'system', label: '系统通知', category: 0, unread: 0 },
        { name: 'team', label: '团队通知', category: 1, unread: 0 },
      ],
      tabsList: [
        {
          page: 1,
          list: [],
          total: 0,
          hasMore: true,
          empty: false,
          category: 1,
        },
        {
          page: 1,
          list: [],
          total: 0,
          hasMore: true,
          empty: false,
          category: 0,
        },
        {
          page: 1,
          list: [],
          total: 0,
          hasMore: true,
          empty: false,
          category: 2,
        },
      ],
      activeTabIndex: 0,
      loading: false,
      scrollPositions: [0, 0, 0], // 存储每个tab的滚动位置
    }
  },
  computed: {
    activeTabCategory() {
      return this.tabs[this.activeTabIndex].category
    },
    enterpriseId() {
      const workspaceStore = useWorkspaceStore()
      return workspaceStore.currentWorkspace.workspaceId
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getUnreadCount()
      this.$nextTick(() => {
        // 找到第一个有未读消息的tab
        const firstUnreadTab = this.tabs.findIndex(tab => tab.unread > 0)
        if (firstUnreadTab >= 0) {
          this.activeTabIndex = firstUnreadTab
        }
        this.getData()
      })
    },
    // 全部已读
    onReadAllClick() {
      setRead({
        ids: [],
        allFlag: true,
      }).then(() => {
        this.updateAllTabUnread()
      })
    },
    // 更新全部tab 的 unread 数量为0
    updateAllTabUnread() {
      this.tabs.forEach((tab) => {
        tab.unread = 0
      })
    },
    onTabClick(index) {
      if (this.activeTabIndex === index) {
        return
      }
      // 保存当前tab的滚动位置
      this.scrollPositions[this.activeTabIndex] = this.$refs.tabsContent.scrollTop

      this.activeTabIndex = index

      // 如果该tab没有数据才请求
      if (this.tabsList[this.activeTabIndex].list.length === 0) {
        this.getData()
      } else {
        // 恢复该tab的滚动位置
        this.$nextTick(() => {
          this.$refs.tabsContent.scrollTop = this.scrollPositions[index]
        })
      }
    },
    handleScroll(e) {
      // 更新当前tab的滚动位置
      this.scrollPositions[this.activeTabIndex] = e.target.scrollTop

      const { scrollHeight, scrollTop, clientHeight } = e.target
      // 距离底部20px时触发加载
      if (
        scrollHeight - scrollTop - clientHeight < 20
        && !this.loading
        && this.tabsList[this.activeTabIndex].hasMore
      ) {
        this.loadMore()
      }
    },

    loadMore() {
      if (this.loading) {
        return
      }
      this.loading = true
      this.tabsList[this.activeTabIndex].page += 1

      getUserFeedTimelineList({
        page: this.tabsList[this.activeTabIndex].page,
        pageSize: 10,
        category: this.activeTabCategory,
        enterpriseId: this.enterpriseId,
      }).then((res) => {
        this.tabsList[this.activeTabIndex].list.push(...res.records)
        this.tabsList[this.activeTabIndex].total = res.total
        this.tabsList[this.activeTabIndex].hasMore = res.pages > this.tabsList[this.activeTabIndex].page
      }).finally(() => {
        this.loading = false
      })
    },

    getData() {
      this.loading = true
      getUserFeedTimelineList({
        page: this.tabsList[this.activeTabIndex].page,
        pageSize: 10,
        category: this.activeTabCategory,
        enterpriseId: this.enterpriseId,
      }).then((res) => {
        this.tabsList[this.activeTabIndex].list = res.records
        this.tabsList[this.activeTabIndex].total = res.total
        this.tabsList[this.activeTabIndex].hasMore = res.pages > this.tabsList[this.activeTabIndex].page
        // 如果第一页的数据为空，则设置 empty 为 true
        this.tabsList[this.activeTabIndex].empty = this.tabsList[this.activeTabIndex].list.length === 0

        // 标记已读
        if (res.records.length > 0 && this.tabs[this.activeTabIndex].unread > 0) {
          setRead({
            ids: res.records.map(item => item.feedId),
          }).then(() => {
            this.getUnreadCount()
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    async getUnreadCount() {
      await getFeedNotReadCountByCategory({
        enterpriseId: this.enterpriseId,
        readType: 0,
      }).then((res) => {
        res.forEach((item) => {
          // 如果 category 为 -1 为总数，不在这里更新
          if (item.category !== -1) {
            this.updateTabUnreadByCategory(item.category, item.count)
          }
        })
      })
    },
    updateTabUnreadByCategory(category, count) {
      this.tabs.find(tab => tab.category === category).unread = count
    },
  },
}
</script>

<template>
  <div class="system-message-notify">
    <div class="content">
      <div class="tabs-header">
        <div class="tab-item-wrap">
          <div v-for="(tab, index) in tabs" :key="tab.name" class="tab-item tab-item"
            :class="[{ active: activeTabIndex === index }]" @click="onTabClick(index)">
            <div class="badge-wrap">
              <span class="label">{{ tab.label }}</span>
              <div v-if="tabs[index].unread" class="badge-sup">
                {{ tabs[index].unread > 99 ? '99+'
                  : tabs[index].unread }}
              </div>
            </div>
          </div>
        </div>
        <div class="read-all" :class="{ 'read-already': tabs.every(tab => tab.unread === 0) }" @click="onReadAllClick">
          全部已读
        </div>
      </div>
      <div ref="tabsContent" class="tabs-contents" @scroll="handleScroll">
        <div v-for="(tab, index) in tabs" v-show="activeTabIndex === index" :key="tab.name"
          :class="`${tab.name}-list list-wrap`">
          <template v-if="tab.name === 'team'">
            <div v-for="item in tabsList[activeTabIndex].list" :key="item.id" class="team-list-item list-item">
              <ReportCard v-if="[63, 64, 65].includes(item.feedConfigId)" is-small :message-data="item" />
              <NotifyCard v-else is-small :message-data="item" @update-handle="getData" />
            </div>
          </template>
          <template v-else>
            <div v-for="item in tabsList[activeTabIndex].list" :key="item.id" class="system-list-item list-item">
              <ReportCard v-if="[63, 64, 65].includes(item.feedConfigId)" is-small :message-data="item" />
              <SystemCard v-else is-small is-popover :message="item" />
            </div>
          </template>
        </div>
        <div v-if="!loading && tabsList[activeTabIndex].empty" class="empty-wrap">
          <i class="icon-empty" />
          <div class="txt">
            暂无通知
          </div>
        </div>

        <div v-if="loading" class="loading">
          <NSpin />
        </div>
      </div>
      <a class="content-footer" :href="`/notify?workspace=${enterpriseId}`" target="_blank">
        查看所有消息 >
      </a>
    </div>
  </div>
</template>

<style lang="scss">
.system-message-notify {
  position: relative;
  width: 400px;
  height: 500px;
  padding: 0 12px 0;
  background: #F0F4FF;
  box-shadow: 0px 0px 30px 0px rgba(109, 125, 196, 0.4);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #FFFFFF;

  &::before {
    content: '';
    width: 100%;
    height: 160px;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url('https://materialdb.zhaoyl.com/fed/system-message-notify-bg.png');
    background-size: cover;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
  }

  .list-wrap {
    // height: 100%;
  }

  .empty-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    background-color: #fff;
    border-radius: 8px;

    .icon-empty {
      width: 80px;
      height: 70px;
      background-image: url('./icon-empty.png');
      background-size: cover;
    }

    .txt {
      margin-top: 10px;
      color: #425466;
      font-size: 12px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
    height: 100%;
  }

  .tabs-header {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #fff;
    flex-shrink: 0;

    .tab-item-wrap {
      display: flex;
      align-items: center;

      .tab-item {

        position: relative;
        margin-right: 30px;
        padding: 0 7px;
        font-size: 14px;
        cursor: pointer;

        .badge-wrap {
          position: relative;
          display: inline-flex;
          align-items: center;

          .badge-sup {
            position: absolute;
            right: -10px;
            top: -6px;
            color: #fff;
            background: #FF4080;
            border-radius: 10px;
            font-size: 12px;
            line-height: 14px;
            padding: 0 4px;
          }
        }

        .label {
          color: #8FA1B2;

        }

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -11px;
          width: 0;
          height: 2px;
          background: #242F57;
          transition: width 0.3s;
        }

        &.active {
          .label {
            color: #242F57;
          }

          &::after {
            width: 20px;
          }
        }
      }
    }

    .read-all {
      font-size: 12px;
      color: #4050FF;
      cursor: pointer;

      &.read-already {
        color: #8FA1B2;
      }
    }
  }

  .tabs-contents {
    flex: 1;
    padding-top: 14px;
    overflow-y: auto;
  }

  .list-item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .content-footer {
    flex-shrink: 0;
    color: #8FA1B2;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 12px;

    &:hover {
      color: #4050FF;
    }
  }

  .loading {
    text-align: center;
    padding: 10px 0;
    color: #8FA1B2;
    font-size: 12px;
  }
}
</style>
